import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@folio/stripes/components';
import useOnlineStatus from '../../hooks/useOnlineStatus';
import css from './OfflineBanner.css';
/**
 * CZNA-1624 — a persistent "Jste offline" bar while the browser has no connection.
 *
 * <p><b>Why not stripes `MessageBanner`.</b> Its outer wrapper is hard-coded `role="alert"`
 * (assertive by role), and the ticket asks for a polite status announcement; wrapping it in a
 * `role="status"` would nest two live regions that a screen reader may announce twice. The bar
 * reuses MessageBanner's warning colours through the same stripes tokens instead.
 *
 * <p><b>Why the region is always mounted, and first committed empty.</b> A live region inserted
 * together with its text is often not announced; one that already exists and changes its
 * content is. So the region is always rendered, and its text appears only after the region has
 * been committed (`mounted`, set in an effect) — also when the module opens DURING an outage,
 * where `useOnlineStatus` already starts offline and would otherwise create the region with
 * its text in the same render. The delay is one effect tick, not visible. Empty, the region
 * takes no height, so nothing moves while online.
 *
 * <p>It is an indication only (ticket bounds): no dismiss button — it goes away by itself when
 * the connection is back — and it blocks nothing. It is rendered once at the module root, in
 * the document flow above the module content (see `src/index.js`), so it never covers the pane
 * footers with Uložit/Zrušit.
 */
var OfflineBanner = function () {
    var online = useOnlineStatus();
    var _a = useState(false), mounted = _a[0], setMounted = _a[1];
    useEffect(function () {
        setMounted(true);
    }, []);
    return (React.createElement("div", { role: "status", "aria-live": "polite", className: css.region }, mounted && !online && (React.createElement("div", { className: css.bar, "data-testid": "czna-offline-banner", "data-test-offline-banner": true },
        React.createElement(Icon, { icon: "exclamation-circle", size: "medium" }),
        React.createElement(FormattedMessage, { id: "ui-czna-authorities.offline.banner" })))));
};
export default OfflineBanner;
